module.exports = __webpack_public_path__ + "img/businessman.8868db32.jpg";